<template>
    <!-- 管理批阅计划 -->
    <div class="board">
        <div v-hasPermi="['review:plan:list']" class="h100p">
            <div class="title">
                <span>
                    <el-button type="text" icon="el-icon-arrow-left" @click="$router.push({name:'achievement'})">{{ editTextConfig.back }}</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <span class="name">{{ editTextConfig.title }}</span>
                </span>
            </div>
            <div class="questionCon" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
                <el-form :inline="true" :model="form" ref="form" label-width="86px" :rules="formRules">
                    <el-form-item :label="formTextConfig.reviewTime" prop="startTime">
                        <el-date-picker
                            class="datePicker"
                            v-model="form.startTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="changeStartTime()"
                            type="datetime"
                            :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())"
                            :picker-options="startPickerOptions"
                            :placeholder="formTextConfig.startTimeTip"
                            style="width:240px">
                        </el-date-picker>&nbsp;&nbsp;-
                    </el-form-item>
                    <el-form-item prop="endTime">
                        <el-date-picker
                            class="datePicker"
                            v-model="form.endTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            :disabled="!form.startTime"
                            default-time="23:59:59"
                            :picker-options="endPickerOptions"
                            :placeholder="formTextConfig.endTimeTip"
                            style="width:240px">
                        </el-date-picker>
                    </el-form-item><br/>

                    <el-form-item :label="formTextConfig.assign">
                        <el-tabs v-model="form.reviewType" type="card" @tab-click="handleClick" >
                            <el-tab-pane :label="formTextConfig.reviewTypeName" name="one" :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())">
                                <div class="progress">
                                    <!-- <i class="el-icon-refresh-left" @click="refreshProgressList"></i> -->
                                    <p v-for="(item, index) in progressList" :key="index">
                                        {{ formTextConfig.subjective }}{{index+1}}
                                        <el-progress :percentage="item.num?item.num*1/reviewTotal*1*100:0" :show-text="false" :stroke-width="12"></el-progress>
                                        <span style="margin-right: 24px">{{ formTextConfig.assigned }}：<b style="width:28px;display:inline-block;text-align:center">{{item.num}}</b> / {{reviewTotal}}</span>
                                        {{ formTextConfig.reviewer }}： <b style="width:24px;display:inline-block;text-align:center">{{item.teacherIdList.length}}</b> {{ formTextConfig.reivewerUnit }}
                                    </p>
                                </div>
                                <p v-for="(e, i) in form.reviewerList" :key="i">
                                    <el-form :model="e" :ref="'formList'+i" :rules="formListRules">
                                        <el-form-item prop="teacherIdList">
                                            <el-select
                                                    v-model="e.teacherIdList"
                                                    @change="changeList(i)"
                                                    multiple
                                                    collapse-tags
                                                    filterable
                                                    :placeholder="formTextConfig.reviewerTip"
                                                    :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())"
                                                    style="width:240px">
                                                <el-option v-for="(item) in teacherList"
                                                           :key="item.userId"
                                                           :label="item.realname"
                                                           :value="item.userId + ''">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item prop="questionId">
                                            <el-select
                                                    v-model="e.questionId"
                                                    @change="changeList(i),changeQuestion(i)"
                                                    :placeholder="formTextConfig.questionIdTip"
                                                    :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())"
                                                    style="width:260px">
                                                <el-option
                                                        v-for="(item,index) in progressList"
                                                        :key="index"
                                                        :label="formTextConfig.subjective + (index+1)"
                                                        :value="item.questionId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item prop="testPaperNum">
                                            <el-input
                                                    v-model="e.testPaperNum"
                                                    @change="changeList(i)"
                                                    type="number"
                                                    :min="1"
                                                    :placeholder="formTextConfig.testPaperNumTip"
                                                    :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())"
                                                    style="width:240px">
                                            </el-input>
                                        </el-form-item>
                                        <el-button
                                                v-if="form.reviewerList.length > 1"
                                                :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())"
                                                type="danger"
                                                plain
                                                icon="el-icon-delete"
                                                @click="deleteList(i)">
                                        </el-button>
                                    </el-form>
                                </p>
                                <el-button
                                        type="primary"
                                        plain
                                        icon="el-icon-plus"
                                        @click="addList"
                                        :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())">
                                </el-button>
                            </el-tab-pane>
                            <el-tab-pane :label="moreFormTextConfig.reviewTypeName" name="more" :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())">
                                <el-form  :model="form" ref="moreForm" label-width="86px" :rules="moreFormRules">
                                    <el-form-item :label="moreFormTextConfig.reviewCount" prop="reviewCount">
                                        <div>{{moreFormTextConfig.perPaper}}
                                            <el-input v-model="form.reviewCount" type="number" :min="2" placeholder=""
                                                      :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())"
                                                      style="width:140px">
                                            </el-input>{{moreFormTextConfig.moreThanOne}}
                                        </div>
                                    </el-form-item><br>
                                    <el-form-item :label="moreFormTextConfig.scoreCalcType" prop="scoreCalcType">
                                        <el-select v-model="form.scoreCalcType" clearable placeholder="" :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())">
                                            <el-option v-for="item in scoreCalcTypes" :key="item.dict_value" :label="item.dict_label" :value="item.dict_value" v-if="item.dict_value != 3"></el-option>
                                        </el-select>
                                    </el-form-item><br>
                                </el-form>
                                <el-row :gutter="20" style="margin-bottom: 20px">
                                    <el-col :span="12">
                                        <div>
                                            <span>{{moreFormTextConfig.subjectivityCondition.name}}</span>
                                            <el-table
                                                    :data="questions"
                                                    max-height="250"
                                                    border
                                                    width="300">
                                                <el-table-column
                                                        align="center"
                                                        prop="questionId"
                                                        :label="moreFormTextConfig.subjectivityCondition.index"
                                                        min-width="100px">
                                                    <template slot-scope="scope">
                                                        <p>{{ formTextConfig.subjective }}{{scope.$index + 1}}</p>
                                                    </template>

                                                </el-table-column>
                                                <el-table-column
                                                        align="center"
                                                        prop="num"
                                                        :label="moreFormTextConfig.subjectivityCondition.num"  show-overflow-tooltip>
                                                    <template slot-scope="scope">
                                                        <p>{{ scope.row.num }}/{{reviewTotal}}</p>
                                                    </template>
                                                </el-table-column>

                                            </el-table>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div>
                                            <span>{{moreFormTextConfig.teacherCondition.name}}</span>
                                            <el-table
                                                    :data="reviewers"
                                                    max-height="250"
                                                    width="300"
                                                    border>
                                                <el-table-column
                                                        align="center"
                                                        prop="teacherId"
                                                        :label="moreFormTextConfig.teacherCondition.teacher">
                                                    <template slot-scope="scope" >
                                                        <p v-for="item in teacherList"  v-if="item.userId + '' == scope.row.teacherId">{{ item.realname }}</p>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        align="center"
                                                        prop="num"
                                                        :label="moreFormTextConfig.teacherCondition.num">
                                                </el-table-column>

                                            </el-table>
                                        </div>
                                    </el-col>
                                </el-row>
                                <p  v-for="(e, i) in form.moreReviewerList" :key="i">
                                    <el-form :model="e" :ref="'moreFormList'+i" :rules="formListRules">
                                        <el-form-item prop="questionId">
                                            <el-select
                                                    v-model="e.questionId"
                                                    @change="changeList(i),changeQuestion(i)"
                                                    :placeholder="formTextConfig.questionIdTip"
                                                    :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())"
                                                    style="width:240px">
                                                <el-option
                                                        v-for="(item,index) in progressList"
                                                        :key="index"
                                                        :label="formTextConfig.subjective + (index+1)"
                                                        :value="item.questionId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item prop="teacherIdList">
                                            <el-select
                                                    v-model="e.teacherIdList"
                                                    @change="changeList(i)"
                                                    multiple
                                                    collapse-tags
                                                    filterable
                                                    :placeholder="formTextConfig.reviewerTip"
                                                    :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())"
                                                    style="width:260px">
                                                <el-option v-for="(item) in teacherList"
                                                           :key="item.userId"
                                                           :label="item.realname"
                                                           :value="item.userId + ''">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item prop="testPaperNum">
                                            <el-input
                                                    v-model="e.testPaperNum"
                                                    @change="changeList(i)"
                                                    type="number"
                                                    :min="1"
                                                    :placeholder="formTextConfig.testPaperNumTip"
                                                    :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())"
                                                    style="width:240px">
                                            </el-input>
                                        </el-form-item>
                                        <el-button
                                                v-if="form.reviewerList.length > 1 || form.moreReviewerList.length > 1"
                                                :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())"
                                                type="danger"
                                                plain
                                                icon="el-icon-delete"
                                                @click="deleteList(i)">
                                        </el-button>
                                    </el-form>
                                </p>
                                <el-button
                                        type="primary"
                                        plain
                                        icon="el-icon-plus"
                                        @click="addList"
                                        :disabled="!isAdd&&form.startTime&&(new Date(form.startTime).getTime()<Date.now())">
                                </el-button>
                            </el-tab-pane>
                        </el-tabs>
                    </el-form-item><br/>
                    <el-form-item label="">
                        <el-button v-hasPermi="['review:result:save']" type="primary" style="margin-left: 86px" @click="submitForm">{{ formTextConfig.ok }}</el-button>
                        <p style="margin-left: 86px;color: #C0C4CC;">{{ formTextConfig.tip }}</p>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { getDownloadAddress } from '@/utils/common.js'
export default {
    data() {
        return {
            loading: false,
            isAdd: true,
            form: {
                id: null,
                startTime: '',
                endTime: '',
                reviewCount: null,
                scoreCalcType: null,
                reviewType: 'one',
                reviewerList: [{teacherIdList: [], questionId: '', testPaperNum: null}],
                moreReviewerList: [{teacherIdList: [], questionId: '', testPaperNum: null}]
            },
            progressList: [],
            teacherList: [],
            reviewTotal: 0,
            startPickerOptions: {
                disabledDate(time) {
                    return new Date(time).getTime() < Date.now() - 8.64e7;
                },
            },
            endPickerOptions: this.disabledDate(),
            formRules: {
                startTime: [{
                    required: true,
                    message: this.$store.state.global.textConfig.backend.achievement.table.button.edit.form.startTimeRule,
                    trigger: 'change'
                }],
                endTime: [{
                    required: true,
                    message: this.$store.state.global.textConfig.backend.achievement.table.button.edit.form.endTimeRule,
                    trigger: 'change'
                }]
            },
            moreFormRules: {
                reviewCount:[{
                    required: true,
                    message: this.$store.state.global.textConfig.backend.achievement.table.button.edit.moreForm.reviewCountNotNull,
                    trigger: 'change'
                }, {
                    validator: this.validateNum,
                    trigger: 'change'
                }, {
                    validator: this.validateReviewCount,
                    trigger: "change"
                }],
                scoreCalcType: [{
                    required: true,
                    message: this.$store.state.global.textConfig.backend.achievement.table.button.edit.moreForm.scoreCalcTypeNotNull,
                    trigger: 'change'
                }]

            },
            formListRules: {
                teacherIdList: [{
                    required: true,
                    message: this.$store.state.global.textConfig.backend.achievement.table.button.edit.form.reviewerRule,
                    trigger: 'change'
                }, {
                    validator: this.validateTeacher,
                    trigger: 'change'
                }],
                questionId: [{
                    required: true,
                    message: this.$store.state.global.textConfig.backend.achievement.table.button.edit.form.questionIdRule,
                    trigger: 'change'
                }],
                testPaperNum: [{
                    required: true,
                    message: this.$store.state.global.textConfig.backend.achievement.table.button.edit.form.testPaperNumRule,
                    trigger: 'change'
                },{
                    validator: this.validateNum,
                    trigger: 'change'
                }]
            },
            scoreCalcTypes:[],
            questions: [],
            reviewers: []
        }
    },
    computed: {
        editTextConfig() {
            return this.$store.state.global.textConfig.backend.achievement.table.button.edit
        },
        formTextConfig() {
            return this.editTextConfig.form
        },
        moreFormTextConfig() {
            return this.editTextConfig.moreForm
        }
    },
    methods: {
        validateNum(rule, value, callback) {
            if (/(^[1-9]\d*$)/g.test(value) === false && value) {
                callback(new Error('仅允许输入正整数'));
            } else {
                callback()
            }
        },
        validateReviewCount(rule, value, callback) {
            if (value && value <= 1) {
                callback(new Error(this.$store.state.global.textConfig.backend.achievement.table.button.edit.moreForm.reviewCountMoreThanOne));
            }  else {
                callback();
            }
        },
        validateTeacher(rule, value, callback) {
            if (this.form.reviewType == 'more') {
                if (value && value.length != this.form.reviewCount) {
                    callback(new Error(this.$store.state.global.textConfig.backend.achievement.table.button.edit.moreForm.teacherNumEqualReviewCount))
                } else {
                    callback()
                }
            } else {
                callback()
            }
            if (/(^[1-9]\d*$)/g.test(value) === false && value) {
                callback(new Error('仅允许输入正整数'));
            } else {
                callback()
            }
        },
        disabledDate() {
            let that = this
            return {
                disabledDate(time) {
                    if (that.isAdd) {
                        return new Date(time).getTime() < new Date(that.form.startTime).getTime() - 8.64e7 +10;
                    }else {
                        return new Date(time).getTime() < Date.now() - 8.64e7;
                    }
                }
            }
        },
        changeStartTime() {
            if (this.form.startTime && this.form.endTime && new Date(this.form.endTime).getTime()-1<new Date(this.form.startTime).getTime()) {
                this.form.endTime = null
            }
        },
        refreshProgressList() {
            for (let i = 0; i < this.progressList.length; i++) {
                const e = this.progressList[i];
                e.num = 0
                e.teacherIdList = []
                for (let j = 0; j < this.form.reviewerList.length; j++) {
                    const f = this.form.reviewerList[j];
                    if (f.teacherIdList && f.questionId && f.testPaperNum) {
                        if (f.questionId === e.questionId) {
                            e.num += f.testPaperNum*f.teacherIdList.length
                            for (let n = 0; n < f.teacherIdList.length; n++) {
                                const m = f.teacherIdList[n];
                                if (e.teacherIdList.indexOf(m) === -1) {
                                    e.teacherIdList.push(m)
                                }
                            }
                        }
                    }
                }
            }
        },
        changeQuestion(i) {
            // let obj = {}
            // obj = this.progressList.find((item)=>{
            //     return item.questionId === this.form.reviewerList[i].questionId
            // });
            if (this.form.reviewType == 'one') {
                for (let j = 0; j < this.progressList.length; j++) {
                    const e = this.progressList[j];
                    if (e.questionId === this.form.reviewerList[i].questionId) {
                        this.form.reviewerList[i].questionSort = j+1
                    }
                }
            } else {
                for (let j = 0; j < this.questions.length; j++) {
                    const e = this.questions[j];
                    if (e.questionId === this.form.moreReviewerList[i].questionId) {
                        this.form.moreReviewerList[i].questionSort = j+1
                    }
                }
                this.refreshMore()
            }

        },
        changeList(i) {
            if (this.form.reviewType == 'one') {
                if (this.form.reviewerList[i].teacherIdList && this.form.reviewerList[i].questionId && this.form.reviewerList[i].testPaperNum) {
                    this.refreshProgressList()
                }
            } else {
                if (this.form.moreReviewerList[i].teacherIdList && this.form.moreReviewerList[i].questionId && this.form.moreReviewerList[i].testPaperNum) {
                    this.refreshMore()
                }
            }
        },
        addList() {
            if (this.form.reviewType == 'one') {
                this.form.reviewerList.push({teacherIdList: [], questionId: '', testPaperNum: null})
            } else {
                this.form.moreReviewerList.push({teacherIdList: [], questionId: '', testPaperNum: null})
            }
        },
        deleteList(i) {
            if (this.form.reviewType == 'one') {
                this.form.reviewerList.splice(i, 1)
                this.refreshProgressList()
            } else {
                this.form.moreReviewerList.splice(i, 1)
                this.refreshMore()
            }
        },
        submitForm() {
            let isOk = true
            if (this.form.reviewType == 'more') {
                this.$refs['moreForm'].validate((valid) => {
                    if (!valid) {
                        isOk = false
                    }
                })
                for (let i = 0; i < this.form.moreReviewerList.length; i++) {
                    this.$refs['moreFormList'+i][0].validate((valid) => {
                        if (!valid) {
                            isOk = false
                        }
                    })
                }
            } else {
                for (let i = 0; i < this.form.reviewerList.length; i++) {
                    this.$refs['formList'+i][0].validate((valid) => {
                        if (!valid) {
                            isOk = false
                        }
                    })
                }
            }
            this.$refs['form'].validate((valid) => {
                if (valid && isOk) {
                    let str = []
                    if (this.form.reviewType == 'one') {
                        for (let i = 0; i < this.progressList.length; i++) {
                            const num = this.progressList[i].num;
                            if (num > this.reviewTotal) {
                                isOk = false
                                str.push(this.formTextConfig.subjective + (i+1))
                            } else if(num < this.reviewTotal) {
                                let tooLittle = this.formTextConfig.tooLittle
                                this.$alert(tooLittle.message, tooLittle.title, { confirmButtonText: tooLittle.ok })
                                return
                            }
                        }
                    } else {
                        let $this = this
                        for(let i = 0; i < $this.questions.length; i++) {
                            const num = this.questions[i].num;
                            if (num > this.reviewTotal) {
                                isOk = false
                                str.push(this.moreFormTextConfig.subjective + (i+1))
                            } else if(num < this.reviewTotal) {
                                let tooLittle = this.moreFormTextConfig.tooLittle
                                this.$alert(tooLittle.message, tooLittle.title, { confirmButtonText: tooLittle.ok })
                                return
                            }
                        }
                    }

                    if (str.length) {
                        if (this.form.reviewType == 'one') {
                            let tooMany = this.formTextConfig.tooMany
                            this.$alert(tooMany.message.signMix(str.join('、')), tooMany.title, {confirmButtonText: tooMany.ok})
                        } else {
                            let tooMany = this.moreFormTextConfig.tooMany
                            this.$alert(tooMany.message.signMix(str.join('、')), tooMany.title, {confirmButtonText: tooMany.ok})
                        }
                    } else {
                        if (this.form.reviewType == 'more') {
                            this.form.reviewerList = this.form.moreReviewerList
                        } else {
                            this.form.reviewCount = null
                            this.form.scoreCalcType = null
                        }
                        if (this.isAdd) {
                            this.$store.dispatch("postReviewPlan", this.form).then(res => {
                                if (res.status === 200) {
                                    this.$message({ type: 'success', message: this.formTextConfig.addSuccess });
                                    this.$router.push({ name:'achievement' })
                                    this.$route.meta.keepAlive = false
                                }
                            })
                        }else {
                            this.$store.dispatch("putReviewPlan", this.form).then(res => {
                                if (res.status === 200) {
                                    this.$message({ type: 'success', message: this.formTextConfig.editSuccess });
                                    this.$router.push({ name:'achievement' })
                                    this.$route.meta.keepAlive = false
                                }
                            })
                        }
                    }
                }
            })
        },
        refreshMore() {
            for (let i = 0; i < this.form.moreReviewerList.length; i++) {
                const f = this.form.moreReviewerList[i];
                if (f.teacherIdList && f.questionId && f.testPaperNum) {
                    for (let j = 0; j < this.questions.length; j++) {
                        const e = this.questions[j];
                        if (i == 0) {
                            e.num = 0
                        }
                        if (f.questionId === e.questionId) {
                            e.num += parseInt(f.testPaperNum)
                        }
                    }
                    if (i == 0) {
                        this.reviewers = []
                    }
                    for (let n = 0; n < f.teacherIdList.length; n++) {
                        const m = f.teacherIdList[n];
                        let reviewer = this.reviewers.find(item => item.teacherId == m)
                        if (reviewer) {
                            reviewer.num += parseInt(f.testPaperNum)
                        } else {
                            this.reviewers.push({"teacherId": m, num: parseInt(f.testPaperNum)})
                        }
                    }
                }

            }
        }
    },
    created() {
        let id = this.$route.query.id
        this.$store.dispatch('getAllReviewer').then(res => {
            if (res.status === 200) {
                this.teacherList = res.data
            }
        })
        this.$store.dispatch('getExamPaperById', this.$route.query.examPaperId).then(res => {
            if (res.status === 200) {
                let list = res.data.confirmed_paper
                let subjectivityList = []
                for (let i = 0; i < list.length; i++) {
                    const e = list[i];
                    if (e.question_type === 'subjectivity') {
                        subjectivityList.push(...e.question_list)
                    }
                }
                for (let i = 0; i < subjectivityList.length; i++) {
                    if (subjectivityList[i].review_mode === 'manual') {
                        this.progressList.push({num:0, teacherIdList:[], questionId: subjectivityList[i].id})
                        this.questions.push({questionId: subjectivityList[i].id,num:0})
                    }
                }
                this.$store.dispatch('getReviewPlanDetail', id).then(res => {
                    if (res.status === 200) {
                        if (res.data.reviewStartTime) {
                            this.isAdd = false
                            this.form.startTime = res.data.reviewStartTime
                            this.form.endTime = res.data.reviewEndTime
                            this.form.reviewType = res.data.reviewType
                            this.form.reviewCount = res.data.reviewCount
                            this.form.reviewerList = []
                            this.form.moreReviewerList = []
                            for (let j = 0; j < res.data.reviewerList.length; j++) {
                                const li = res.data.reviewerList[j];
                                if (res.data.reviewType == "one") {
                                    if ( li.teacherIdList) {
                                        this.form.reviewerList.push({teacherIdList: li.teacherIdList, questionId: li.questionId, testPaperNum: li.testPaperNum, questionSort: li.questionSort})
                                    } else {
                                        this.form.reviewerList.push({teacherIdList: [li.teacherId], questionId: li.questionId, testPaperNum: li.testPaperNum, questionSort: li.questionSort})
                                    }
                                } else {
                                    this.form.moreReviewerList.push({teacherIdList: li.teacherIdList, questionId: li.questionId, testPaperNum: li.testPaperNum, questionSort: li.questionSort})
                                }

                            }
                            if (res.data.reviewType == "one") {
                                this.refreshProgressList()
                            } else {
                                this.refreshMore()
                            }
                        }
                        this.form.id = id
                        this.reviewTotal = res.data.reviewTotal
                    }
                })
            }
        })
        this.$store.dispatch("getDict", 'score_calc_type').then(res => {
            this.scoreCalcTypes = res.data
            if (this.scoreCalcTypes && this.scoreCalcTypes.length > 0) {
                this.form.scoreCalcType = this.scoreCalcTypes[0].dict_value
            }
        });
    },
}
</script>

<style scoped>
.questionCon {
    overflow: auto;
}
.progress {
    background: #ebeef5;
    border-radius: 4px;
    width: 700px;
    padding: 14px 20px;
    margin-bottom: 20px;
    position: relative;
}
.el-progress {
    width: 340px;
    display: inline-block;
    margin: 0px 26px;
    position: relative;
    top: 1px;
}
.el-progress >>> .el-progress-bar__outer {
    background-color: #fff;
}
/* .el-icon-refresh-left {
    float: right;
    font-size: 21px;
    color: #0070de;
    cursor: pointer;
} */

</style>
